var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M15 28c7.2 0 13-5.8 13-13S22.2 2 15 2 2 7.8 2 15s5.8 13 13 13zm0 2C6.7 30 0 23.3 0 15S6.7 0 15 0s15 6.7 15 15-6.7 15-15 15zm-1-18h2v10h-2V12zm0-4h2v2h-2V8z","fillRule":"nonzero"})));
}

Info.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Info;

Info.default = Info;
